import { render, staticRenderFns } from "./DomainAdminWelcomeScreen.vue?vue&type=template&id=3c8028ea"
import script from "./DomainAdminWelcomeScreen.vue?vue&type=script&lang=js"
export * from "./DomainAdminWelcomeScreen.vue?vue&type=script&lang=js"
import style0 from "./DomainAdminWelcomeScreen.vue?vue&type=style&index=0&id=3c8028ea&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c8028ea')) {
      api.createRecord('3c8028ea', component.options)
    } else {
      api.reload('3c8028ea', component.options)
    }
    module.hot.accept("./DomainAdminWelcomeScreen.vue?vue&type=template&id=3c8028ea", function () {
      api.rerender('3c8028ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Auth/DomainAdminWelcomeScreen.vue"
export default component.exports